export const PRACTICE_REGIONS = {
  EAST: 'East Coast',
  WEST: 'West Coast'
};
